<script setup lang="ts">
type Props = {
  endDate: Date;
  finished: boolean;
  useTextFormat?: boolean;
  useColorCoding?: boolean;
  precision?: "seconds" | "relative";
};

const { endDate, finished, precision } = defineProps<Props>();

type Emits = {
  (e: "timer-finished"): void;
};

const emit = defineEmits<Emits>();

const { timeLeft, colorCodedClass } = useCountdown(
  () => endDate,
  {
    countdownFinished: () => emit("timer-finished"),
  },
  () => precision,
);

const twoUnitFormatTimeLeft = useTwoUnitCountdownFormat(timeLeft);
const truncatedLongFormatTimeLeft = useTruncatedLongCountdownFormat(timeLeft);

onMounted(() => {
  // If no time is left, but the finished property wasn't updated yet,
  // trigger the 'timer finished' callback
  if (!timeLeft.value && !finished) {
    emit("timer-finished");
  }
});
</script>

<template>
  <div
    :class="
      useColorCoding
        ? `${colorCodedClass} countdown-timer`
        : 'bg-platform-color-1 text-platform-color-2'
    "
  >
    <span>
      <span v-if="finished">{{ $t("product.finished") }}</span>
      <span v-else>
        {{
          (useTextFormat
            ? truncatedLongFormatTimeLeft
            : twoUnitFormatTimeLeft) || "..."
        }}
      </span>
    </span>
  </div>
</template>
